// Mock data for the WOD-Admin only widgets shown at the top of the WOD Landing Page.
// These will eventually be replaced by real data coming from the corresponding Services
// (PaymentService, DirectoryService, etc.) - for now they're hardcoded so we can build
// the UI first and wire up the real data afterwards.

export const monthlyRevenue = {
  current: 7975.0,
  change: 5410.48,
  isPositive: true,
  predicted: 11699.06,
  // Simple trend used to draw the sparkline (last 8 data points)
  trend: [3200, 3050, 3100, 3300, 4200, 5800, 7200, 7975]
};

export const customerActivity = {
  active: { percentage: 57.4, change: 0.0 },
  semiActive: { percentage: 39.2, change: 0.0 },
  inactive: { percentage: 3.4, change: 0.0 }
};

export const upcomingBirthdays = [
  { id: 1, name: 'Paul Smith', avatar: null, date: '2026-08-10' },
  { id: 2, name: 'Paula Jones', avatar: null, date: '2026-08-10' },
  { id: 3, name: 'Paul Anderson', avatar: null, date: '2026-08-10' },
  { id: 4, name: 'Paula White', avatar: null, date: '2026-08-10' }
];
